const characters = 'abcdefghijklmnopqrstuvwxyz0123456789-_'; // base 64

export const StringService = {
  generate(length = 32): string {
    return [...new Array(length)]
      .map(() => characters[Math.floor(Math.random() * characters.length) % characters.length])
      .join('');
  },

  camelToKebab(string: string): string {
    return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  },

  capitalize(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },

  kebabToCamel(string: string): string {
    return string.replace(/-([a-z])/g, (_, s) => s.toUpperCase());
  },

  kebabToCamelSpace(string: string): string {
    return string.replace(/-([a-z])/g, (_, s) => ` ${s.toUpperCase()}`);
  },

  kebabToPascalSpace(string: string): string {
    const transformed = StringService.kebabToCamelSpace(string);
    return `${transformed.substr(0, 1).toUpperCase()}${transformed.substr(1)}`;
  },

  stringToObject<T>(input: unknown): T | string {
    if (`${input}`[0] === '{' || `${input}`[0] === '[') {
      try {
        return typeof input === 'string' ? JSON.parse(input) : input;
      } catch { /* empty */ }
    }
    return input as string;
  },

  toTitleCase(sentence: string): string {
    return sentence
      .split(' ')
      .map((word) => [word[0].toUpperCase(), ...word.substr(1)].join(''))
      .join(' ');
  },

  isVideoUrl(url: string): boolean {
    const splitUrl = url.split('.');
    const extension = splitUrl[splitUrl.length - 1];
    return ['mp4', 'webm', 'avi'].indexOf(extension.toLowerCase()) >= 0;
  },

  getExtension: (filename: string): string | undefined => filename.split('.').pop()?.toLowerCase(),
};
